'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldCaptureVisitorEmailAddress = undefined;

var _reselect = require('reselect');

var _getCaptureVisitorEmailAddress = require('conversations-schema/operators/message/getCaptureVisitorEmailAddress');

var _getWelcomeMessage = require('./getWelcomeMessage');

var shouldCaptureVisitorEmailAddress = exports.shouldCaptureVisitorEmailAddress = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, _getCaptureVisitorEmailAddress.getCaptureVisitorEmailAddress);


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/shouldCaptureVisitorEmailAddress.js
// module id = 369
// module chunks = 2 3